<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Generate Payment Sheet</h2>
          <div class="row my-4">
            <div class="col-9">
              <div class="d-flex">
                <date-picker v-model="orderDates" range class="me-3" placeholder="Select Order Dates"></date-picker>
                <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
                <button v-else  class="btn btn-info me-1 w-100 btn-lg">Generate Excel Sheet with Preselected Orders</button>
                <button  class="btn btn-info me-1 w-100 btn-lg">Generate Excel Sheet</button>
              </div>
            </div>
          </div>
        </div>
        <div class="px-4 pb-4 mt-5">
          <h2 class="card-title-desc">Upload Payment Sheet</h2> {{file}}
          <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              v-on:vdropzone-file-added="onAccept"
              v-on:vdropzone-removed-file="removeFile"
          >
            <div class="dropzone-custom-content">
              <i class="display-4 text-muted bx bxs-cloud-upload"></i>
              <h4>Drop files here or click to upload.</h4>
            </div>
          </vue-dropzone>
          <div class="mt-3 align-middle">
            <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="httpLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="primary" size="lg" class="py-3 h3 text-white w-100" type="submit" v-else>
              Upload Bulk Payment Excel Sheet
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config.json";
import PageHeader from "@/components/page-header";
import vue2Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {mapGetters} from "vuex";
export default {
  page: {
    title: "Bulk Payments Processing",
    meta: [{ name: "description", content: appConfig.description }]
  },
  name: "bulk-payments-processing",
  components: {Layout, PageHeader, vueDropzone: vue2Dropzone},
  data(){
    return {
      title: "Bulk Payments Processing",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Bulk Payments Processing",
          active: true
        }
      ],
      orderDates: "",
      file: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        addRemoveLinks: true
        // accept: (file) => {
        //   this.onAccept(file);
        // },
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    }),
  },
  methods: {
    onAccept(file) {
      this.file = file
      console.log('add', this.file)
    },
    removeFile(){
      this.file = ""
      console.log('remove', this.file)
    }
  }
}
</script>

<style scoped>

</style>
